import React, { useState, memo } from 'react';
import { Search, Menu, X } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Shop All',
    href: '#shop'
  }, {
    name: 'Cards',
    href: '#shop'
  }, {
    name: 'Memorabilia',
    href: '#memorabilia'
  }];
  return <header className="sticky top-0 z-50 w-full bg-ink text-white h-[60px] md:h-auto" data-id="element-82">
      <div className="container mx-auto px-4 h-full flex items-center justify-between" data-id="element-83">
        {/* Logo */}
        <a href="#" className="flex items-center z-50 h-full" data-id="element-84">
          <span className="font-heading text-2xl md:text-3xl tracking-wide text-white mt-1" data-id="element-85">
            BUCKNUT
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-86">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-bold uppercase tracking-wider hover:text-scarlet transition-colors relative group py-6" data-id="element-87">
              {link.name}
              <span className="absolute bottom-0 left-0 w-full h-1 bg-scarlet transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left" data-id="element-88"></span>
            </a>)}
        </nav>

        {/* Icons */}
        <div className="flex items-center space-x-2 md:space-x-4 z-50" data-id="element-89">
          <button className="p-2 hover:text-scarlet transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Search" data-id="element-90">
            <Search className="w-5 h-5" data-id="element-91" />
          </button>
          <button className="md:hidden p-2 hover:text-scarlet transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-92">
            {isMenuOpen ? <X className="w-6 h-6" data-id="element-93" /> : <Menu className="w-6 h-6" data-id="element-94" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden absolute top-[60px] left-0 w-full bg-ink border-t border-white/10 shadow-xl" data-id="element-95">
          <nav className="flex flex-col px-4 py-4 space-y-2" data-id="element-96">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-bold uppercase tracking-wider py-3 hover:text-scarlet transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-97">
                {link.name}
              </a>)}
          </nav>
        </div>}
    </header>;
};